import { Check, FileCopyOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import copy from "copy-to-clipboard";
import { useState } from "react";
import { useLazyGetShortenUrlByOrderIdQuery } from "src/_api/authApi";

export default function CopyTrackingUrl({orderId, text}) {
    //======= Copy Tracking URL =========
    const [getShortenUrlByOrderId, { isLoading: getShortenUrlByOrderIdLoading }] = useLazyGetShortenUrlByOrderIdQuery()
    const [isCopied, setIsCopied] = useState(false)

    const copyUrlHandler = async (e) => {
        try {
            e.stopPropagation()
            let response = await getShortenUrlByOrderId(orderId).unwrap()
            copy(`${window.location.origin}/${response?.trackUrl}`)
        } catch (error) {
            copy(`${window.location.origin}/customer/track/${orderId}`)
        }finally{
            setIsCopied(true)
            setTimeout(() => {
                setIsCopied(false)
            }, 3000);
        }
    }

    return (
        <LoadingButton
            onClick={copyUrlHandler}
            loading={getShortenUrlByOrderIdLoading}
            sx={{ textTransform: "none" }}
        >
            {isCopied ? <Check color="success" sx={{ mr: 1 }} /> : <FileCopyOutlined sx={{ mr: 1 }} />}
            {text}
        </LoadingButton>
    )
}
/**
 * /merchant/orders/warehouse_orders_zone
 * /merchant/tasks/66c469c21c70e800155058cb
 * /merchant/orders/warehouse_orders_zone
 * /merchant/orders/list
 */